<template>
  <div class="tab-content refund-content">
    <div class="refund-page">
      <main class="main-content">
        <section class="refund-section">
          <div class="container">
            <div class="header-area">
              <h1>{{ t('refund.title') }}</h1>
              <p class="subtitle">{{ t('refund.subtitle') }}</p>
              <div class="notice-banner">
                <span class="notice-icon">💡</span>
                <p>{{ t('refund.noticeBanner') }}</p>
              </div>
            </div>

            <div class="policy-content">
              <div class="policy-card success-border">
                <div class="card-header">
                  <div class="icon-box success-icon">✓</div>
                  <h2>{{ t('refund.fullRefundTitle') }}</h2>
                </div>
                <div class="card-body">
                  <div class="scenario-grid">
                    <div class="scenario-item">
                      <h3><i class="dot"></i> {{ t('refund.physicalSimTitle') }}</h3>
                      <p>{{ t('refund.physicalSimDesc') }}</p>
                    </div>
                    <div class="scenario-item">
                      <h3><i class="dot"></i> {{ t('refund.esimTitle') }}</h3>
                      <p>{{ t('refund.esimDesc') }}</p>
                    </div>
                    <div class="scenario-item">
                      <h3><i class="dot"></i> {{ t('refund.techTitle') }}</h3>
                      <p>{{ t('refund.techDesc') }}</p>
                    </div>
                    <div class="scenario-item">
                      <h3><i class="dot"></i> {{ t('refund.orderTitle') }}</h3>
                      <p>{{ t('refund.orderDesc') }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="policy-card warning-border">
                <div class="card-header">
                  <div class="icon-box warning-icon">↻</div>
                  <h2>{{ t('refund.partialRefundTitle') }}</h2>
                </div>
                <div class="card-body">
                  <ul class="custom-list">
                    <li>
                      <strong>{{ t('refund.networkIssueTitle') }}</strong>
                      {{ t('refund.networkIssueDesc') }}
                    </li>
                    <li>
                      <strong>{{ t('refund.nonHumanIssueTitle') }}</strong>
                      {{ t('refund.nonHumanIssueDesc') }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="policy-card danger-border">
                <div class="card-header">
                  <div class="icon-box danger-icon">✕</div>
                  <h2>{{ t('refund.noRefundTitle') }}</h2>
                </div>
                <div class="card-body">
                  <div class="danger-grid">
                    <div class="danger-item">
                      <span class="badge">{{ t('refund.badgeUsed') }}</span>
                      <p>{{ t('refund.descUsed') }}</p>
                    </div>
                    <div class="danger-item">
                      <span class="badge">{{ t('refund.badgeDevice') }}</span>
                      <p>{{ t('refund.descDevice') }}</p>
                    </div>
                    <div class="danger-item">
                      <span class="badge">{{ t('refund.badgePersonal') }}</span>
                      <p>{{ t('refund.descPersonal') }}</p>
                    </div>
                    <div class="danger-item">
                      <span class="badge">{{ t('refund.badgeExpiry') }}</span>
                      <p>{{ t('refund.descExpiry') }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="policy-card process-card">
                <div class="card-header">
                  <div class="icon-box info-icon">📋</div>
                  <h2>{{ t('refund.processTitle') }}</h2>
                </div>
                <div class="card-body">
                  <div class="step-flow">
                    <div class="step-item">
                      <div class="step-number">01</div>
                      <div class="step-info">
                        <h3>{{ t('refund.step1Title') }}</h3>
                        <p>{{ t('refund.step1Desc') }}</p>
                      </div>
                    </div>
                    <div class="step-item">
                      <div class="step-number">02</div>
                      <div class="step-info">
                        <h3>{{ t('refund.step2Title') }}</h3>
                        <p>{{ t('refund.step2Desc') }}</p>
                      </div>
                    </div>
                    <div class="step-item">
                      <div class="step-number">03</div>
                      <div class="step-info">
                        <h3>{{ t('refund.step3Title') }}</h3>
                        <p>{{ t('refund.step3Desc') }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="special-notice">
                <div class="notice-title">{{ t('refund.specialTitle') }}</div>
                <p>
                  {{ t('refund.specialDescPre') }}
                  <strong>{{ t('refund.specialDescHighlight') }}</strong>
                  {{ t('refund.specialDescPost') }}
                  <strong>{{ t('refund.specialDescNotice') }}</strong>
                  {{ t('refund.specialDescEnd') }}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import i18nData from '@/i18n/locales.js'

export default {
  name: 'RefundTab',
  props: {
    lang: { type: String, default: 'zh' }
  },
  data() {
    return {
      i18n: i18nData
    }
  },
  methods: {
    t(key) {
      const keys = key.split('.')
      let val = this.i18n[this.lang]
      for (const k of keys) {
        if (val && val[k] !== undefined) {
          val = val[k]
        } else {
          return key
        }
      }
      return val
    }
  }
}
</script>

<style scoped>
@import '../assets/styles/refund.css';
</style>